import { lazy } from 'react';

const TagRoutes = [
  {
    path: 'catalog/labels',
    component: lazy(() => import('views/labels')),
  },
];

export default TagRoutes;
